export default __webpack_public_path__ + "static/media/HBC.e9ad6fb7.svg";